import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { FluidModule } from 'primeng/fluid';
import { RouterLink } from '@angular/router';
import { Location } from '@angular/common';
import { LogoComponent } from '../../logomarca/logomarca';


@Component({
  selector: 'app-not-found',
  imports: [FluidModule, ButtonModule, FormsModule, LogoComponent],
  templateUrl: './404.html'
})
export class Notfound {

  private location = inject(Location);

  voltar(): void {
    this.location.back();
  }

}